import { child, ref } from "firebase/database";
import { useObjectVal } from "react-firebase-hooks/database";
import { fbDatabase } from "../firebase";

export interface EntitlementData {
  supporter?: {
    active: boolean;
    grantedDate: number;
  };
  pro?: {
    active: boolean;
    grantedDate: number;
    expiresAt: number | null;
  };
}

function refEntitlements() { return ref(fbDatabase, "entitlements/"); }
function refEntitlement(uid: string) { return child(refEntitlements(), uid); }

/** Fetch a user's entitlements. Readable by any authenticated user. */
export function useEntitlements(uid: string | undefined) {
  return useObjectVal<EntitlementData>(uid ? refEntitlement(uid) : undefined);
}

/** Check if a board owner is Pro (for board session entitlement checks). */
export function useIsProOwner(ownerUid: string | undefined) {
  const [entitlements, loading, error] = useEntitlements(ownerUid);
  return [entitlements?.pro?.active === true, loading, error] as const;
}
